export enum Font {
    OBJECT_SANS = 'OBJECT_SANS',
}

export const fonts: {[key in Font]:string} = {
    [Font.OBJECT_SANS]: `"Object Sans", sans-serif`,
};

export const getFont = (font:Font):string => fonts[font]